module.exports = __webpack_public_path__ + "static/seinfeld_0-e19e475b0eabf845f97f53688fe68956.jpg";